<div class="modal-content border-0 shadow-lg">
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi {{ icon }} {{ iconClass }} me-2"></i>
      <span>{{ title }}</span>
    </h5>
    <button type="button" class="btn-close" (click)="activeModal.dismiss()" aria-label="Close"></button>
  </div>

  <div class="modal-body p-4">
    <p class="mb-2">{{ message }}</p>
    @if (warning) {
      <p class="text-muted small mb-0">{{ warning }}</p>
    }
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">
      <span>{{ cancelText }}</span>
    </button>
    <button type="button" class="btn {{ confirmClass }}" (click)="activeModal.close(true)">
      <span>{{ confirmText }}</span>
    </button>
  </div>
</div>
